import {
  EnrollmentContext,
  LIFE_EVENT_ENROLLMENT_TYPE,
  NEW_HIRE_ENROLLMENT_TYPE,
  OPEN_ENROLLMENT_TYPE,
} from 'theSource/queries';
import { calcDaysLeft } from 'enrollment/features/EnrollmentDashboard/utils/utils';
import { LifeEventCard, EnrollmentCard } from '..';
import { formatDateString } from '../../utils';

export interface ContextCardProps {
  enrollmentContext: EnrollmentContext;
  cardIndex: number;
  allContexts?: EnrollmentContext[];
  planYearStart?: string;
  planYearEnd?: string;
}

export const ContextCard = ({
  enrollmentContext,
  cardIndex,
  allContexts,
}: ContextCardProps) => {
  const enrollmentStatus = enrollmentContext.status;

  const enrollmentEndsOn = enrollmentContext.enrollment_ends_on;
  let daysLeftOfEnrollment = 0;
  if (enrollmentEndsOn) {
    daysLeftOfEnrollment = calcDaysLeft(new Date(enrollmentEndsOn || ''));
  }

  const renderCardByContext = (context: EnrollmentContext) => {
    const planYearEndsOn = enrollmentContext.plan_year_ends_on.toString();

    const props = {
      enrollmentContext: context,
      cardIndex: cardIndex,
      allContexts: allContexts,
    };

    switch (context.enrollment_type_lookup_code) {
      case LIFE_EVENT_ENROLLMENT_TYPE:
        // the default plan year is always the one that is active but not completed. The next_plan_year_id will show the later plan year if it exists.
        const defaultPY = context.default_org_plan_year_id;
        const py = context.included_plan_years.find(
          (year) => year.id === defaultPY
        );
        return (
          <LifeEventCard
            {...props}
            planYearStart={formatDateString(py?.starts_on.toString())}
            planYearEnd={formatDateString(py?.ends_on.toString())}
          />
        );
      case NEW_HIRE_ENROLLMENT_TYPE:
      case OPEN_ENROLLMENT_TYPE:
        return (
          <EnrollmentCard
            {...props}
            planYearStart={formatDateString(
              context.plan_year_starts_on.toString()
            )}
            planYearEnd={formatDateString(planYearEndsOn)}
          />
        );
      default:
        return <></>;
    }
  };

  if (
    enrollmentStatus === 'not_open' ||
    (enrollmentStatus === 'started' &&
      daysLeftOfEnrollment < 1 &&
      !(
        enrollmentContext.enrollment_type_lookup_code ===
        LIFE_EVENT_ENROLLMENT_TYPE
      ))
  ) {
    return <div className="" data-testid="no-enrollment-context-card"></div>;
  } else {
    return renderCardByContext(enrollmentContext);
  }
};
